<template>
  <div v-if="loading" style="flex-wrap:wrap;" class="d-flex justify-content-center">
    <div v-if="loading" class="spinner-border text-primary" style="text-align:center;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="col-sm-12" style="flex-basis:100%;height:0;">
    </div>
    <span style="color:black;">Loading...</span>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
